var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.07 16.43a3.93 3.93 0 010-7.86h2.14a.36.36 0 00.36-.36v-.35a2.14 2.14 0 00-1.95-2.14l-3.2-4.9a1.79 1.79 0 00-2.48-.53L2.64 5.7h-.5A2.14 2.14 0 000 7.86v10A2.14 2.14 0 002.14 20h14.29a2.14 2.14 0 002.14-2.14v-1.07a.36.36 0 00-.36-.36zM11.82 2.29l2.24 3.42h-7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.57 10h-2.5a2.5 2.5 0 000 5h2.5A1.43 1.43 0 0020 13.57v-2.14A1.43 1.43 0 0018.57 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.38bbf2f1.svg";
export { ForwardRef as ReactComponent };